(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lowPower =
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
    (navigator.deviceMemory && navigator.deviceMemory <= 4);

  function getHeroSection() {
    return document.querySelector('.hero-wrapper');
  }

  function makeSoftDiscTexture(hexColor, feather) {
    var size = 128;
    var c = document.createElement('canvas');
    c.width = c.height = size;
    var ctx = c.getContext('2d');
    var grad = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    grad.addColorStop(0, hexColor.replace('ALPHA', feather[0]));
    grad.addColorStop(0.6, hexColor.replace('ALPHA', feather[1]));
    grad.addColorStop(1, hexColor.replace('ALPHA', '0'));
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size, size);
    return new THREE.CanvasTexture(c);
  }

  function init() {
    var heroSection = getHeroSection();
    if (!heroSection || typeof THREE === 'undefined') return;
    if (heroSection.querySelector('canvas[data-panoplia-scene]')) return;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('data-panoplia-scene', '');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:absolute;inset:0;width:100%;height:100%;z-index:0;pointer-events:none;display:block;';
    heroSection.style.position = heroSection.style.position || 'relative';
    heroSection.insertBefore(canvas, heroSection.firstChild);

    var width = heroSection.clientWidth || window.innerWidth;
    var height = heroSection.clientHeight || 600;
    var isMobile = window.innerWidth < 750;

    var scene = new THREE.Scene();
    scene.fog = new THREE.FogExp2(0x0a0810, isMobile ? 0.028 : 0.02);

    var camera = new THREE.PerspectiveCamera(42, width / height, 0.1, 100);
    camera.position.set(1.2, 0.4, 13);

    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    } catch (e) {
      return;
    }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isMobile ? 1.5 : 2));
    renderer.setSize(width, height);
    if (renderer.outputColorSpace !== undefined) renderer.outputColorSpace = THREE.SRGBColorSpace;

    /* ---------- Lighting: cinematic, warm key + cool rim + soft fill ---------- */
    scene.add(new THREE.AmbientLight(0x2a2440, 0.55));

    var key = new THREE.PointLight(0xffcf9e, 2.2, 26, 2);
    key.position.set(5, 4.5, 7);
    scene.add(key);

    var rim = new THREE.PointLight(0x8a6bff, 1.4, 30, 2);
    rim.position.set(-6, 1, -3);
    scene.add(rim);

    var fill = new THREE.PointLight(0xffe9c7, 0.5, 20, 2);
    fill.position.set(2, -3, 6);
    scene.add(fill);

    /* ---------- Fake volumetric light shafts (additive soft sprites) ---------- */
    var shaftTex = makeSoftDiscTexture('rgba(255,201,120,ALPHA)', ['0.55', '0.18']);
    var shafts = [];
    if (!lowPower) {
      var shaftDefs = [
        { x: 3.2, y: 1.5, z: -4, scale: 9, color: 0xffcf9e },
        { x: -3.5, y: 0.5, z: -6, scale: 11, color: 0x9a7bff },
      ];
      shaftDefs.forEach(function (d) {
        var mat = new THREE.SpriteMaterial({
          map: shaftTex,
          color: d.color,
          transparent: true,
          opacity: 0.35,
          depthWrite: false,
          blending: THREE.AdditiveBlending,
        });
        var sprite = new THREE.Sprite(mat);
        sprite.position.set(d.x, d.y, d.z);
        sprite.scale.set(d.scale, d.scale * 1.4, 1);
        scene.add(sprite);
        shafts.push(sprite);
      });
    }

    /* ---------- Soft contact-shadow blobs ---------- */
    var shadowTex = makeSoftDiscTexture('rgba(0,0,0,ALPHA)', ['0.5', '0.22']);
    var shadowGroup = new THREE.Group();
    scene.add(shadowGroup);

    function addShadow(x, z, scale) {
      var mat = new THREE.SpriteMaterial({ map: shadowTex, transparent: true, depthWrite: false });
      var s = new THREE.Sprite(mat);
      s.position.set(x, -3.6, z);
      s.scale.set(scale, scale * 0.35, 1);
      shadowGroup.add(s);
      return s;
    }

    /* ---------- Materials ---------- */
    var gold = new THREE.MeshStandardMaterial({ color: 0xd8ab5c, metalness: 0.85, roughness: 0.28 });
    var goldBright = new THREE.MeshStandardMaterial({ color: 0xe9c581, metalness: 0.9, roughness: 0.2 });
    var charcoal = new THREE.MeshStandardMaterial({ color: 0x211b2c, metalness: 0.35, roughness: 0.55 });
    var burgundy = new THREE.MeshStandardMaterial({ color: 0x5c1f2e, metalness: 0.5, roughness: 0.4 });
    var violet = new THREE.MeshStandardMaterial({ color: 0x4a2f66, metalness: 0.55, roughness: 0.35 });
    var cream = new THREE.MeshStandardMaterial({ color: 0xf3e6c8, metalness: 0.1, roughness: 0.6 });

    var floaters = []; // { group, baseY, speed, offset, spin }

    function registerFloater(group, x, y, z, opts) {
      opts = opts || {};
      group.position.set(x, y, z);
      scene.add(group);
      floaters.push({
        group: group,
        baseY: y,
        speed: opts.speed || 0.35 + Math.random() * 0.2,
        offset: Math.random() * Math.PI * 2,
        spinY: opts.spinY || 0,
        spinX: opts.spinX || 0,
        amp: opts.amp || 0.18,
      });
      if (opts.shadow !== false) addShadow(x, z, opts.shadowScale || 1.6);
    }

    /* ---------- 1. Mannequin / dress form wearing an elegant costume ---------- */
    /* The single most important shape for "this is a costume shop": a headless-style
       tailor's dummy on a slender stand, wearing a flared gown or cape, with a gold
       trim collar. Two colour/silhouette variants are used (see composition below). */
    function buildMannequin(bodyMat, trimMat, opts) {
      opts = opts || {};
      var g = new THREE.Group();

      var base = new THREE.Mesh(new THREE.CylinderGeometry(0.3, 0.34, 0.05, 20), charcoal);
      base.position.y = -1.85;
      g.add(base);

      var pole = new THREE.Mesh(new THREE.CylinderGeometry(0.02, 0.02, 0.9, 8), charcoal);
      pole.position.y = -1.35;
      g.add(pole);

      /* flared gown / cape body — the flare itself reads instantly as "garment" */
      var gown = new THREE.Mesh(
        new THREE.CylinderGeometry(0.34, opts.hem || 0.92, 1.9, 28, 1, false),
        bodyMat
      );
      gown.position.y = -0.9;
      g.add(gown);

      var waistBand = new THREE.Mesh(new THREE.TorusGeometry(0.35, 0.028, 8, 28), trimMat);
      waistBand.position.y = 0.02;
      waistBand.rotation.x = Math.PI / 2;
      g.add(waistBand);

      var neck = new THREE.Mesh(new THREE.CylinderGeometry(0.12, 0.14, 0.22, 16), bodyMat);
      neck.position.y = 0.16;
      g.add(neck);

      /* stand-up collar / cape clasp — reinforces "costume", not just "dress form" */
      var collar = new THREE.Mesh(new THREE.TorusGeometry(0.24, 0.05, 10, 24, Math.PI * 1.4), trimMat);
      collar.position.y = 0.3;
      collar.rotation.x = Math.PI / 2 + 0.1;
      collar.rotation.z = Math.PI * 0.3;
      g.add(collar);

      /* faceless, elegant head — mysterious/premium rather than childish */
      var head = new THREE.Mesh(new THREE.SphereGeometry(0.22, 20, 16), cream);
      head.scale.set(0.85, 1.15, 0.9);
      head.position.y = 0.62;
      g.add(head);

      if (opts.cape) {
        /* a wider, solid cone worn OVER the gown's upper half — always visible
           (no reliance on open/backface geometry that can disappear from some angles) */
        var capeMat = new THREE.MeshStandardMaterial({
          color: opts.capeColor || 0x2c1b3d,
          metalness: 0.4,
          roughness: 0.5,
        });
        var capeHeight = 1.15;
        var cape = new THREE.Mesh(new THREE.CylinderGeometry(0.4, 1.35, capeHeight, 28), capeMat);
        cape.position.y = 0.05 - capeHeight / 2;
        g.add(cape);
      }

      g.rotation.y = opts.turn !== undefined ? opts.turn : 0.35;
      return g;
    }

    /* ---------- 2. Hat (top hat: crown + wide brim + gold band) ---------- */
    function buildTopHat() {
      var g = new THREE.Group();
      var crown = new THREE.Mesh(new THREE.CylinderGeometry(0.62, 0.62, 1.15, 28), charcoal);
      crown.position.y = 0.58;
      g.add(crown);
      var brim = new THREE.Mesh(new THREE.CylinderGeometry(1.05, 1.05, 0.08, 32), charcoal);
      brim.position.y = 0.02;
      g.add(brim);
      var band = new THREE.Mesh(new THREE.TorusGeometry(0.63, 0.07, 10, 32), gold);
      band.position.y = 0.18;
      band.rotation.x = Math.PI / 2;
      g.add(band);
      return g;
    }

    /* ---------- 3. Venetian mask — a flattened, forward-facing plate (not a
       partial sphere shell) so the eyes / brow / nose / trim are guaranteed to sit
       on the visible face rather than hidden inside a bowl shape ---------- */
    function buildVenetianMask() {
      var g = new THREE.Group();

      var shell = new THREE.Mesh(new THREE.SphereGeometry(1, 32, 24), goldBright);
      shell.scale.set(0.78, 1.05, 0.4);
      g.add(shell);

      var eyeGeo = new THREE.SphereGeometry(0.13, 16, 12);
      var eyeL = new THREE.Mesh(eyeGeo, charcoal);
      eyeL.position.set(-0.27, 0.08, 0.34);
      eyeL.scale.set(1.3, 0.7, 0.5);
      g.add(eyeL);
      var eyeR = eyeL.clone();
      eyeR.position.x = 0.27;
      g.add(eyeR);

      var browGeo = new THREE.TorusGeometry(0.16, 0.02, 6, 16, Math.PI * 0.75);
      var browL = new THREE.Mesh(browGeo, gold);
      browL.position.set(-0.27, 0.24, 0.3);
      browL.rotation.z = Math.PI * 0.12;
      g.add(browL);
      var browR = browL.clone();
      browR.position.x = 0.27;
      browR.rotation.z = Math.PI - Math.PI * 0.12;
      g.add(browR);

      var nose = new THREE.Mesh(new THREE.ConeGeometry(0.075, 0.3, 10), goldBright);
      nose.position.set(0, -0.08, 0.42);
      nose.rotation.x = Math.PI / 2;
      g.add(nose);

      var trim = new THREE.Mesh(new THREE.TorusGeometry(0.97, 0.032, 8, 48), gold);
      trim.scale.set(0.8, 1.05, 1);
      g.add(trim);

      /* side feather plume — the classic Venetian-mask flourish */
      var plumeGroup = new THREE.Group();
      var featherMats = [burgundy, gold, violet];
      for (var i = 0; i < 3; i++) {
        var feather = new THREE.Mesh(new THREE.ConeGeometry(0.05, 0.62 - i * 0.09, 8), featherMats[i]);
        feather.position.set(0.04 * i, 0.14 + i * 0.11, 0.05);
        feather.rotation.z = -0.5 - i * 0.18;
        plumeGroup.add(feather);
      }
      plumeGroup.position.set(0.68, 0.55, 0.1);
      g.add(plumeGroup);

      g.scale.setScalar(0.95);
      return g;
    }

    /* ---------- 4. Carnival / masquerade mask — same flattened forward-facing
       approach as the Venetian mask, smaller and in jewel violet with a gold
       upswept temple flourish (distinct silhouette from the mask above) ---------- */
    function buildCarnivalMask() {
      var g = new THREE.Group();

      var shell = new THREE.Mesh(new THREE.SphereGeometry(0.62, 24, 18), violet);
      shell.scale.set(0.85, 0.95, 0.42);
      g.add(shell);

      var eyeGeo = new THREE.SphereGeometry(0.09, 14, 10);
      var eyeL = new THREE.Mesh(eyeGeo, charcoal);
      eyeL.position.set(-0.19, 0.05, 0.22);
      eyeL.scale.set(1.3, 0.7, 0.5);
      g.add(eyeL);
      var eyeR = eyeL.clone();
      eyeR.position.x = 0.19;
      g.add(eyeR);

      var trim = new THREE.Mesh(new THREE.TorusGeometry(0.58, 0.024, 6, 32), gold);
      trim.scale.set(0.86, 0.96, 1);
      g.add(trim);

      var flourish = new THREE.Mesh(new THREE.ConeGeometry(0.045, 0.36, 8), gold);
      flourish.position.set(0.42, 0.32, 0.06);
      flourish.rotation.z = -0.6;
      g.add(flourish);

      return g;
    }

    /* ---------- 5. Balloon (sphere + thin string) — a single festive accent ---------- */
    function buildBalloon(material, scale) {
      var g = new THREE.Group();
      var body = new THREE.Mesh(new THREE.SphereGeometry(0.5, 24, 20), material);
      body.scale.set(1, 1.2, 1);
      g.add(body);
      var tip = new THREE.Mesh(new THREE.ConeGeometry(0.05, 0.12, 8), material);
      tip.position.y = -0.62;
      g.add(tip);
      var stringGeo = new THREE.CylinderGeometry(0.006, 0.006, 1.4, 4);
      var stringMat = new THREE.MeshBasicMaterial({ color: 0x3a3346 });
      var str = new THREE.Mesh(stringGeo, stringMat);
      str.position.y = -1.35;
      g.add(str);
      g.scale.setScalar(scale);
      return g;
    }

    /* ---------- 6. Small accent ring (jewellery / accessory) ---------- */
    function buildAccentRing() {
      var g = new THREE.Group();
      var ring = new THREE.Mesh(new THREE.TorusGeometry(0.32, 0.09, 12, 28), gold);
      g.add(ring);
      return g;
    }

    /* Composition: an intimate luxury-showroom arrangement biased to the right/
       background, generous empty space on the left for the hero text. Every object
       reads immediately as "costume shop": a dressed mannequin, a detailed Venetian
       mask, a top hat and a small accessory are always present (including on
       mobile); a second mannequin, a carnival mask and one balloon are added on
       desktop for a fuller but still uncluttered showcase (7 objects max). */
    registerFloater(buildMannequin(burgundy, gold, { hem: 0.85, turn: 0.4 }), 4.8, -0.3, -1.2, {
      speed: 0.18,
      spinY: 0.015,
      shadowScale: 2.4,
    });
    registerFloater(buildVenetianMask(), 7.0, 1.4, 0.6, { speed: 0.4, spinY: 0.09, shadowScale: 1.6 });
    registerFloater(buildTopHat(), 4.0, 2.1, 1.6, { speed: 0.3, spinY: 0.05, shadowScale: 1.4 });
    registerFloater(buildAccentRing(), 3.5, -1.8, 2.3, {
      speed: 0.55,
      spinY: 0.18,
      spinX: 0.1,
      shadowScale: 0.8,
    });

    if (!isMobile) {
      registerFloater(buildMannequin(violet, gold, { hem: 1.05, cape: true, turn: -0.3 }), 8.2, -0.2, -4.6, {
        speed: 0.15,
        spinY: -0.012,
        shadowScale: 2.8,
      });
      registerFloater(buildCarnivalMask(), 9.8, 0.6, -1.0, { speed: 0.35, spinY: -0.07, shadowScale: 1.1 });
      registerFloater(buildBalloon(gold, 0.8), 8.5, 3.3, -1, { speed: 0.3, shadow: false });
    }

    /* ---------- Confetti (lightweight point sprites) ---------- */
    var confetti = null;
    if (!lowPower) {
      var confettiCount = isMobile ? 26 : 50;
      var confettiGeo = new THREE.BufferGeometry();
      var positions = new Float32Array(confettiCount * 3);
      var colorsArr = new Float32Array(confettiCount * 3);
      var confColors = [
        [0.85, 0.67, 0.36], // gold
        [0.6, 0.24, 0.32], // burgundy
        [0.58, 0.42, 0.8], // violet
        [0.95, 0.9, 0.8], // cream
      ];
      for (var i = 0; i < confettiCount; i++) {
        positions[i * 3] = (Math.random() - 0.3) * 12 + 2;
        positions[i * 3 + 1] = Math.random() * 8 - 2;
        positions[i * 3 + 2] = (Math.random() - 0.5) * 8 - 2;
        var c = confColors[i % confColors.length];
        colorsArr[i * 3] = c[0];
        colorsArr[i * 3 + 1] = c[1];
        colorsArr[i * 3 + 2] = c[2];
      }
      confettiGeo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      confettiGeo.setAttribute('color', new THREE.BufferAttribute(colorsArr, 3));
      var confettiMat = new THREE.PointsMaterial({
        size: 0.09,
        vertexColors: true,
        transparent: true,
        opacity: 0.75,
        depthWrite: false,
      });
      confetti = new THREE.Points(confettiGeo, confettiMat);
      scene.add(confetti);
    }

    /* ---------- Interaction: mouse parallax + scroll ---------- */
    var mouseX = 0,
      mouseY = 0,
      curX = 0,
      curY = 0;
    window.addEventListener(
      'pointermove',
      function (e) {
        mouseX = (e.clientX / window.innerWidth) * 2 - 1;
        mouseY = (e.clientY / window.innerHeight) * 2 - 1;
      },
      { passive: true }
    );

    var scrollFactor = 0;
    window.addEventListener(
      'scroll',
      function () {
        scrollFactor = Math.min(window.scrollY / 800, 1);
      },
      { passive: true }
    );

    function onResize() {
      width = heroSection.clientWidth;
      height = heroSection.clientHeight;
      if (!width || !height) return;
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
      renderer.setSize(width, height);
    }
    window.addEventListener('resize', onResize, { passive: true });

    var running = true;
    document.addEventListener('visibilitychange', function () {
      running = document.visibilityState === 'visible';
    });

    function renderFrame() {
      renderer.render(scene, camera);
    }

    if (reduceMotion) {
      renderFrame();
      return;
    }

    var clock = new THREE.Clock();

    function animate() {
      requestAnimationFrame(animate);
      if (!running) return;

      var t = clock.getElapsedTime();

      curX += (mouseX * 0.9 - curX) * 0.025;
      curY += (mouseY * 0.6 - curY) * 0.025;

      camera.position.x = 1.2 + curX;
      camera.position.y = 0.4 - curY - scrollFactor * 1.8;
      camera.lookAt(2.4, -scrollFactor * 1.2, -1);

      for (var i = 0; i < floaters.length; i++) {
        var f = floaters[i];
        f.group.position.y = f.baseY + Math.sin(t * f.speed + f.offset) * f.amp;
        if (f.spinY) f.group.rotation.y += f.spinY * 0.01;
        if (f.spinX) f.group.rotation.x = Math.sin(t * 0.3 + f.offset) * 0.15;
      }

      if (confetti) {
        var pos = confetti.geometry.attributes.position;
        for (var j = 0; j < pos.count; j++) {
          var y = pos.getY(j) - 0.004;
          if (y < -4) y = 6;
          pos.setY(j, y);
          pos.setX(j, pos.getX(j) + Math.sin(t * 0.5 + j) * 0.0015);
        }
        pos.needsUpdate = true;
      }

      for (var k = 0; k < shafts.length; k++) {
        shafts[k].material.opacity = 0.28 + Math.sin(t * 0.15 + k) * 0.07;
      }

      renderFrame();
    }

    animate();
  }

  function loadThree(callback) {
    if (window.THREE) {
      callback();
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    script.async = true;
    script.onload = callback;
    script.onerror = function () {
      /* Three.js failed to load: hero keeps its dark background, nothing breaks. */
    };
    document.head.appendChild(script);
  }

  function boot() {
    var heroSection = getHeroSection();
    if (!heroSection) return;

    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        function () {
          loadThree(init);
        },
        { timeout: 2000 }
      );
    } else {
      setTimeout(function () {
        loadThree(init);
      }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
